export default "__VITE_ASSET__B2P5IwNy__"